import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthJwtService } from '../../services/auth-jwt.service';
import { DynamicCssService } from '../../services/dynamic-css.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  imports: [RouterOutlet,
    RouterLink,
    RouterLinkActive
  ],
  selector: 'app-default-layout',
  standalone: true,
  templateUrl: './default-layout.component.html',
  styles: [
    `
    body {
      transition: opacity 0.3s ease-in-out;
    }
    `
  ]
})

export class DefaultLayoutComponent implements OnInit, OnDestroy {
  pageTitle = 'Programas';
  isSidebarCollapsed = false;
  menuState: Record<string, boolean> = {};
  private routerSubscription?: Subscription;
  private readonly collapseBreakpoint = 767.98;

  private readonly menuRoutePrefixes: Record<string, string[]> = {
    usuarios: ['/admin/user'],
    programas: [
      '/admin/program',
      '/admin/program-company',
      '/admin/program-company-vehicle',
      '/admin/program-company-user'
    ],
    vehiculos: [
      '/admin/vehicle-type'
    ]
  };

  private readonly pageTitles: Array<{ prefix: string; title: string }> = [
    { prefix: '/home', title: 'Inicio' },
    { prefix: '/admin/user', title: 'Usuarios' },
    { prefix: '/admin/program', title: 'Programas' },
    { prefix: '/admin/vehicle-type', title: 'Tipos de vehículo' }
  ];

  constructor(
    private router: Router,
    private authJwtService: AuthJwtService,
    private dynamicCss: DynamicCssService
  ) {
  }

  ngOnInit() {
    this.isSidebarCollapsed = window.innerWidth <= this.collapseBreakpoint;
    document.body.style.opacity = '0';
    this.dynamicCss.loadStylesheetLink('admin.css', 'admin-css').then(() => {
      document.body.style.opacity = '1';
    });
    this.dynamicCss.loadStylesheetLink(
      'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-icons/1.11.0/font/bootstrap-icons.min.css',
      'bootstrap-icons'
    );
    this.syncMenusWithRoute(this.router.url);
    this.updatePageTitle(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => {
        this.syncMenusWithRoute(event.urlAfterRedirects);
        this.updatePageTitle(event.urlAfterRedirects);
      });
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  toggleMenu(key: string): void {
    const submenu: HTMLElement = document.querySelector(`[data-ap-parent="${key}"]`);
    if (submenu) {
      let maxHeight = 0;
      const links = submenu.querySelectorAll('.nav-link');
      links.forEach((link: HTMLElement) => {
        maxHeight += link.offsetHeight;
      });
      submenu.style.maxHeight = `${maxHeight}px`;
    }
    this.menuState[key] = !this.isMenuOpen(key);

    if (!this.menuState[key]) {
      submenu.style.maxHeight = '0';
    }
  }

  isMenuOpen(key: string): boolean {
    return Boolean(this.menuState[key]);
  }

  private syncMenusWithRoute(url: string): void {
    let hasOpenMenu = false;
    for (const key of Object.keys(this.menuRoutePrefixes)) {
      const isOpen = this.menuRoutePrefixes[key].some(prefix => url.startsWith(prefix));
      this.menuState[key] = isOpen;
      console.log(key, isOpen);
      if (isOpen) {
        hasOpenMenu = true;
        break;
      }
    }
    if (!hasOpenMenu) {
      this.menuState['programas'] = true;
    }
  }

  private updatePageTitle(url: string): void {
    const match = this.pageTitles.find(item => url.startsWith(item.prefix));
    this.pageTitle = match ? match.title : 'Programas';
    document.title = `SIM Ambassador Program - ${this.pageTitle}`;
  }

  logout(): void {
    this.authJwtService.logout();
    this.router.navigate(['/login']);
  }
}

